import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22855 20552"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#fefefe;stroke-width:253.272}.fil0{fill:#231f20}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613602208">
        <path
          d="M11625 10753c-1155-139-2204 683-2344 1838-139 1154 683 2203 1838 2343 1154 140 2203-683 2343-1837 140-1155-683-2204-1837-2344z"
          className="fill stroke1"
          style={{
            strokeWidth: 253.272,
          }}
        />
        <path
          d="M13246 10133c-99 176-158 272-158 272l-209-129s64-95 165-263c99-166 237-411 379-715 286-608 574-1470 691-2366 36-223 45-448 66-670 2-222 20-441 9-652-10-212-9-418-35-611-22-193-31-378-65-544-27-168-53-322-76-458-32-135-59-252-82-349-46-193-72-304-72-304s30 110 83 302c26 96 57 212 93 346 28 136 58 289 92 456 40 167 55 352 84 545 33 194 38 400 56 614 19 213 8 434 13 659-13 224-16 454-44 681-87 912-351 1802-623 2435-136 317-268 573-367 751zm1085-6925c-29-107-60-212-95-315-2-8-4-16-7-25l-1 1c-672-1961-2235-3122-3660-2629-1542 531-2336 2792-1774 5048 122 491 301 939 519 1338l-2 2s731 1229 469 2755l1 1c-37 288-24 588 50 883 44 177 108 340 187 491 472-307 1050-457 1652-384 556 67 1043 315 1418 674 33-40 64-81 93-123 539-742 2333-3627 1150-7717zM8084 12811c-193-3-475 0-810 29-669 56-1559 237-2393 585-211 80-412 185-614 277-193 109-392 203-569 319-178 114-357 216-511 335-156 116-312 215-440 328-131 108-251 208-358 296-101 94-189 177-261 245-145 136-227 214-227 214s80-81 220-222c70-70 155-156 253-254 104-92 221-195 349-308 124-118 277-223 430-345 151-125 328-233 503-355 176-123 373-224 565-341 201-101 400-214 611-302 834-381 1736-597 2421-678 343-41 630-55 834-58 202-3 314 0 314 0l-6 245s-115-7-311-10zm1000 1009c-220-515-250-1061-126-1565-51-8-102-15-153-19-912-95-4307-207-7258 2863-78 78-154 158-225 239-6 6-12 12-18 19h1c-1363 1563-1586 3496-447 4485 1231 1069 3586 626 5259-988 364-352 663-731 899-1119l3 1s698-1247 2151-1784v-1c269-112 521-273 741-485 131-126 239-264 331-407-502-255-920-681-1158-1239zM18052 19668c-96-25-212-56-346-92-132-44-280-94-442-148-164-49-331-128-514-200-183-69-365-167-559-259-194-90-380-210-577-318-188-123-385-240-568-379-746-531-1385-1204-1797-1756-207-277-362-519-467-694-104-173-157-272-157-272l216-117s51 103 146 274c93 169 237 411 430 687 383 551 985 1232 1703 1780 175 143 365 264 547 393 191 112 372 238 561 334 188 97 366 201 545 275 179 77 343 162 505 216 159 60 305 114 434 162 133 41 248 76 343 104 191 57 299 90 299 90s-109-29-302-80zm1152-5279c-487-140-964-208-1419-219v-3s-1430 19-2621-971h-1c-231-176-498-314-790-398-175-51-349-76-518-84 30 562-130 1138-494 1623-336 447-794 746-1292 892 18 47 38 95 60 141 373 837 1974 3834 6108 4855 107 27 214 54 319 75 9 2 17 4 26 6v-2c2034 400 3820-374 4107-1854 310-1601-1250-3419-3485-4061z"
          className="fill stroke1"
          style={{
            strokeWidth: 253.272,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
